/** @type {import('next-i18next').UserConfig} */
module.exports = {
    appendNamespaceToMissingKey: true,
    debug: process.env.NODE_ENV === 'development',
    defaultNS: 'common',
    ns: ['common'],
    i18n: {
        defaultLocale: 'default',
        locales: ['default', 'zh-HK', 'en-US'],
        localeDetection: false,
        reloadOnPrerender: process.env.NODE_ENV === 'development',
    },
    localePath: (locale, ns, missing) => {
        if (locale === 'default') {
            return `./public/locales/en-us/${ns}.json`;
        }
        return `./public/locales/${locale}/${ns}.json`;
    },
    serializeConfig: false,
};
